"use strict";

const navList = document.querySelectorAll(".nav__list-el");
const containers = document.querySelectorAll(".container");
const containersMob = document.querySelectorAll(".container--mobile");
const containersDesk = document.querySelectorAll(".container--desk");
let btnClicked = true;
let prevNumb = 1;


let btn = document.querySelector('.btn-mobile')

btn.addEventListener("click", (e) =>{
    btn.classList.toggle('btn-mobile-enabled');
    if (btnClicked == true){
        btnClicked = false;

        for (let i = 0; i < containers.length; i++) {
            if (containersDesk[i].classList.contains('show')) {
                containersDesk[i].classList.remove('show');
                containersMob[i].classList.add('show');
            }
        }

    } else {
        btnClicked = true;

        for (let i = 0; i < containers.length; i++) {
            if (containersMob[i].classList.contains('show')) {
                containersMob[i].classList.remove('show');
                containersDesk[i].classList.add('show');
            }
        }
    }
})


for(let i = 0; i < navList.length; i++){
   
    navList[i].addEventListener("click", (e) => {
        e.preventDefault();
        let numb = i;

        for (let i = 0; i < containers.length; i++) {
            if (containers[i].classList.contains('show')) {
                containers[i].classList.remove('show');
            }
        }

        if (btnClicked == true){
            containersDesk[numb].classList.add('show');
        } else {
            containersMob[numb].classList.add('show');
        }
    })
}